export const IMAGEFLUX_BASE_URL_MAP = {
  production: 'https://p2-f82ad187.imageflux.jp',
  staging: 'https://p2-c31a028b.imageflux.jp',
  local: 'http://kiwi.lvh.me:8089/__mock_image_flux__',
};
